import { render, staticRenderFns } from "./AiArtistAnalystv2.vue?vue&type=template&id=70ebb7b0&scoped=true&"
import script from "./AiArtistAnalystv2.vue?vue&type=script&lang=js&"
export * from "./AiArtistAnalystv2.vue?vue&type=script&lang=js&"
import style0 from "./AiArtistAnalystv2.vue?vue&type=style&index=0&id=70ebb7b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ebb7b0",
  null
  
)

export default component.exports